export const LOGIN = 'LOGIN';
export const LOGOUT = 'LOGOUT';

export const SET_START_LOADING_MAIN_SCREEN = 'SET_START_LOADING_MAIN_SCREEN';
export const SET_STOP_LOADING_MAIN_SCREEN = 'SET_STOP_LOADING_MAIN_SCREEN';
export const SET_START_LOADING_ALL_SCREEN = 'SET_START_LOADING_ALL_SCREEN';
export const SET_STOP_LOADING_ALL_SCREEN = 'SET_STOP_LOADING_ALL_SCREEN';

export const ADD_INFO_USER = 'ADD_INFO_USER';
export const REMOVE_INFO_USER = 'REMOVE_INFO_USER';

export const REMOVE_ALL_LIST_DATA = 'REMOVE_ALL_LIST_DATA';

export const REMOVE_ALL_STATE = 'REMOVE_ALL_STATE';

export const LOAD_ALL_DEVICE = 'LOAD_ALL_DEVICE';
export const SET_INFO_AN_USER = 'SET_INFO_AN_USER';
export const ADD_DEVICE = 'ADD_DEVICE';
export const REMOVE_DEVICE = 'REMOVE_DEVICE';
export const LOAD_DETAIL_DEVICE = 'LOAD_DETAIL_DEVICE';

export const LOAD_USER_LIST_DEVICE = 'LOAD_USER_LIST_DEVICE';

export const SET_LIST_DEVICE_TO_USER = 'SET_LIST_DEVICE_TO_USER';

export const LOAD_LIST_ALL_USER = 'LOAD_LIST_ALL_USER';
export const ADD_USER = 'ADD_USER';
export const REMOVE_USER = 'REMOVE_USER';
export const SET_LIST_ALL_USER = 'SET_LIST_ALL_USER';
export const CHANGE_PASSWORD_USER = 'CHANGE_PASSWORD_USER';

export const SEND_REMOTE_SETTING = 'SEND_REMOTE_SETTING';

export const REMOTE_SETTING = "REMOTE_SETTING";


export const READ_NOTE_REMOTE_SETTING = "READ_NOTE_REMOTE_SETTING";


// WEBPACK FOOTER //
// ./src/store/mutation-types.js